const debtor = {
	index: {
		account: {
			description: "In diesem Abschnitt finden Sie die bei uns hinterlegten Kontoinformationen.",
			success: "Ihre Kontoinformationen wurden erfolgreich aktualisiert!",
			title: "Kontoinformationen",
		},
		address: {
			description: "In diesem Abschnitt finden Sie Ihre Adressdaten.",
			success: "Ihre Adressdaten wurden erfolgreich aktualisiert!",
			title: "Adressinformationen",
		},
		title: "Persönlich",
	},
	notifications: {
		description: "In diesem Abschnitt finden Sie alle Benachrichtigungen",
		table: {
			received: "Erhaltene Benachrichtigung",
			timestamp: "Erhalten am",
		},
		title: "Benachrichtigungen",
	},
	security: {
		modal_setup: {
			description: "Befolgen Sie die folgenden Schritte, um 2FA zu Ihrem Konto hinzuzufügen.",
			step_1: {
				description: "Scannen Sie den unten stehenden QR-Code mit einer Authenticator-App.",
				title: "Schritt 1",
			},
			step_2: {
				description: "Bestätigen Sie den 2FA-Code, der sich in der Authenticator-App befindet",
				placeholder: "6-stelliger Code",
				title: "Schritt 2",
			},
			success: "2FA wurde erfolgreich auf Ihrem Konto aktiviert.",
			title: "2FA einrichten",
		},
		modal_unset: {
			description: "Befolgen Sie die folgenden Schritte, um 2FA für Ihr Konto zu deaktivieren.",
			step_1: {
				description:
					"Bestätigen Sie, dass Sie 2FA tatsächlich deaktivieren möchten, indem Sie Ihr Passwort eingeben.",
				placeholder: "Ihr Passwort",
				title: "Schritt 1",
			},
			step_2: {
				description: "Bestätigen Sie den 2FA-Code, der sich in der Authenticator-App befindet",
				placeholder: "6-stelliger Code",
				title: "Schritt 2",
			},
			success: "2FA wurde erfolgreich auf Ihrem Konto deaktiviert.",
			title: "2FA deaktivieren",
			warning:
				"Achtung! Durch Deaktivierung von 2FA wird es Hackern leichter gemacht, auf Ihr Konto zuzugreifen.",
		},
		section1: {
			apps: {
				description:
					"Für 2FA verwenden wir das universelle OAuth. Vielleicht haben Sie bereits eine App. Andernfalls können Sie eine der unten aufgeführten Apps verwenden.",
				title: "Authenticator-Anwendungen",
			},
			description:
				"Die Zwei-Faktor-Authentifizierung (2FA) ist eine Authentifizierungsmethode, bei der Sie zwei erfolgreiche Schritte durchlaufen müssen, um auf etwas zuzugreifen. Rechts finden Sie einige Apps, die Sie dafür verwenden können.",
			title: "Was ist 2FA?",
		},
		section2: {
			description:
				"Wir empfehlen unseren Benutzern, die 2FA anzuwenden. Durch die Hinzufügung zusätzlicher Verifizierung wird Ihr Konto besser geschützt.",
			title: "2FA aktivieren",
		},
		status: {
			active: {
				button: "2FA deaktivieren",
				description: "Ihr Konto ist mit 2FA (Zwei-Faktor-Authentifizierung) zusätzlich gesichert.",
				title: "2FA eingerichtet",
			},
			inactive: {
				button: "2FA aktivieren",
				description:
					"Achtung! Sie haben noch keine 2FA (Zwei-Faktor-Authentifizierung) hinzugefügt.",
				title: "2FA nicht eingerichtet",
			},
		},
	},
	ssh: {
		description: "Hier finden Sie die SSH-Schlüssel, die mit Ihrem Konto verknüpft sind.",
		dialog: {
			create: {
				description:
					"Fügen Sie hier Ihren neuen öffentlichen SSH-Schlüssel hinzu. Dieser wird in Ihrem Konto gespeichert und kann Ihren VPS-Instanzen hinzugefügt werden.",
				external_description:
					"Fügen Sie hier Ihren externen öffentlichen SSH-Schlüssel hinzu. Sie können jeweils 1 SSH-Schlüssel in dieses Feld eintragen.",
				external_title: "Externen SSH-Schlüssel hinzufügen",
				form: {
					description: {
						label: "Beschreibung",
						placeholder: "Geben Sie Ihrem SSH-Schlüssel eine Beschreibung.",
					},
					public_key: {
						label: "Öffentlicher SSH-Schlüssel",
						placeholder: "Geben Sie Ihren eindeutigen SSH-Schlüssel ein.",
					},
					type: {
						label: "Typ",
						placeholder: "Geben Sie Ihrem SSH-Schlüssel einen Typ",
					},
				},
				status: {
					success: "SSH-Schlüssel wurde hinzugefügt!",
					unknown:
						"Derzeit kann kein SSH-Schlüssel hinzugefügt werden. Bitte versuchen Sie es später erneut.",
				},
				title: "SSH-Schlüssel hinzufügen",
			},
			delete: {
				description:
					"Möchten Sie den SSH-Schlüssel mit der Beschreibung <strong>{{description}}</strong> löschen?",
				status: {
					success: "SSH-Schlüssel wurde gelöscht!",
					unknown:
						"Derzeit kann der SSH-Schlüssel nicht gelöscht werden. Bitte versuchen Sie es später erneut.",
				},
				title: "SSH-Schlüssel löschen",
			},
			edit: {
				description: "Bearbeiten Sie hier Ihren hinzugefügten öffentlichen SSH-Schlüssel.",
				external_description:
					"Bearbeiten Sie hier Ihren hinzugefügten externen öffentlichen SSH-Schlüssel.",
				external_title: "Externen SSH-Schlüssel bearbeiten",
				form: {
					description: {
						label: "Beschreibung",
						placeholder: "Geben Sie Ihrem SSH-Schlüssel eine Beschreibung.",
					},
					public_key: {
						label: "Öffentlicher SSH-Schlüssel",
						placeholder: "Geben Sie Ihren eindeutigen SSH-Schlüssel ein.",
					},
					type: {
						label: "Typ",
						placeholder: "Geben Sie Ihrem SSH-Schlüssel einen Typ",
					},
				},
				title: "SSH-Schlüssel bearbeiten",
			},
		},
		invalid:
			"Der von Ihnen eingegebene SSH-Schlüssel ist kein gültiger öffentlicher SSH-Schlüssel. Bitte überprüfen Sie, ob der SSH-Schlüssel korrekt eingegeben wurde.\n Wenn Sie sicher sind, dass der öffentliche SSH-Schlüssel korrekt ist, wenden Sie sich bitte an den Support.",
		item: {
			description: "Beschreibung",
			description_missing: "Keine Beschreibung im SSH-Schlüssel",
			ssh_key: "Öffentlicher SSH-Schlüssel",
			type: "Typ",
		},
		title: "SSH-Schlüssel",
	},
	tabs: {
		connections: "Verbundene Apps",
		debtor_information: "Details zum Konto",
		log: "Aktivitätenprotokoll",
		notifications: "Benachrichtigungen",
		security: "Sicherheit (2FA)",
		ssh_keys: "SSH-Schlüssel",
		update_information: "Anmeldeinformationen",
	},
	update_login_info: {
		password: {
			description: "In diesem Abschnitt können Sie Ihr aktuelles Passwort ändern.",
			success: "Ihr Passwort wurde erfolgreich aktualisiert!",
			title: "Passwort ändern",
		},
		username: {
			description:
				"In diesem Abschnitt können Sie Ihren Benutzernamen ändern. <br/><br/><i><strong>Beachten Sie:</strong> Um Ihren Benutzernamen zu ändern, müssen Sie Ihr aktuelles Passwort eingeben.</i>",
			success: "Ihr Benutzername wurde erfolgreich aktualisiert!",
			title: "Benutzernamen ändern",
		},
	},
};

export default debtor;
